import { Chip, ChipProps } from '@mui/material';

export const TagChip = ({ sx, ...rest }: ChipProps) => {
    return <Chip sx={{ ...sx, borderRadius: 0.3 }} {...rest} />;
};
